export default "__VITE_ASSET__79cc1a09__"